import QRCode from 'qrcode'

const firstValue = (source, keys, fallback = '') => {
  for (const key of keys) {
    const value = source?.[key]
    if (value !== undefined && value !== null && value !== '') return value
  }
  return fallback
}

export async function resolveInvoiceQr (invoice, sellerSnapshot = {}) {
  const suppliedQr =
    invoice?.qr_code || invoice?.qr || invoice?.qr_code_url || ''

  if (
    typeof suppliedQr === 'string' &&
    (suppliedQr.startsWith('data:') || suppliedQr.startsWith('http'))
  ) {
    return suppliedQr
  }

  const seller = sellerSnapshot?.business_info || sellerSnapshot?.business || sellerSnapshot
  const qrText =
    suppliedQr ||
    [
      `Seller: ${firstValue(seller, ['name_en', 'seller_name', 'name'], invoice?.seller_name || '')}`,
      `Arabic Seller: ${firstValue(seller, ['name_ar', 'legal_name_ar'], '')}`,
      `CR: ${firstValue(seller, ['cr_number', 'commercial_registration'], '')}`,
      `VAT: ${firstValue(seller, ['vat_number', 'tin', 'tax_number'], '')}`,
      `Invoice: ${invoice?.invoice_number || ''}`,
      `Date: ${invoice?.created_at || ''}`,
      `Total: ${invoice?.grand_total ?? ''}`,
      `VAT Amount: ${invoice?.vat_amount ?? ''}`
    ]
      .filter(line => !line.endsWith(': '))
      .join('\n')

  try {
    return await QRCode.toDataURL(qrText, {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: 240,
      color: { dark: '#000000', light: '#ffffff' }
    })
  } catch {
    return ''
  }
}
